import faker from 'faker'

export const mocker = {
  IndaxTable (params) {
    const page = params.page || 1
    const limit = params.limit || 10
    let mockIndex = []
    let staappr = ''
    const dataAmount = Math.floor(Math.random() * 100) + limit
    const mockStaappr = [ 'P', 'Y', 'N', 'A', 'C' ]
    const mockStatus = {
      'P': 'รอพิจารณา',
      'Y': 'อนุมัติ',
      'N': 'ไม่อนุมัติ',
      'A': 'ระหว่างอนุมัติ',
      'C': 'ยกเลิก'
    }
    for (var i = 0; i < limit; i++) {
      staappr = mockStaappr[Math.floor(Math.random() * 5)]
      mockIndex.push({
        checkbox: '',
        dtereq: new Date(),
        seqno: ((page - 1) * limit) + i + 1,
        dtework: faker.date.past().toString().substr(4, 12),
        descStareq: mockStatus[staappr],
        remarkap: faker.lorem.words(),
        descCodappr: faker.name.findName(),
        descCodempap: faker.name.findName()
      })
    }
    return {
      total: dataAmount,
      rows: mockIndex
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/hres6de/mocker.js